export default __webpack_public_path__ + "static/media/enter-pay.4e62fe4d.png";